export default {
  specialBonuses(state) {
    return state.specialBonuses;
  },
  totalSpecialBonuses(state) {
    return state.totalSpecialBonuses;
  }
};
